/**
 * Copyright (c) 2026 Constructor Technology AG. All rights reserved.
 *
 * Proprietary and confidential. Unauthorized copying, distribution, or use
 * is prohibited.
 *
 * SPDX-License-Identifier: LicenseRef-Constructor-Proprietary
 */

import Vue from 'vue';
import Moment from 'moment';

// Set default locale
Moment.locale('en');

Vue.moment = Moment;
